import React from 'react';
import '../../styles/shared.css';
import '../../styles/PrebidTab.css';

interface PrebidTabProps {
    handleForm: any;
}

const PrebidTab: React.FC<PrebidTabProps> = ({ handleForm }) => {
    return (
        <div className="general-settings-container">
            <div className="settings-section">
                <h3 className="section-title" data-icon="⚡">Configurações de Performance</h3>

                <div className="row g-3">
                    <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group">
                        <label htmlFor="prebid[timeout]" className="form-label">
                            Timeout Principal
                            <span className="text-muted small d-block">Tempo limite em milissegundos</span>
                        </label>
                        <input
                            type="number"
                            id="prebid[timeout]"
                            name="prebid[timeout]"
                            className="form-control"
                            onChange={handleForm.handleChange}
                            value={handleForm.values.prebid.timeout}
                            placeholder="1000"
                            min="100"
                            max="5000"
                        />
                    </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group">
                        <label htmlFor="prebid[failSafeTimeout]" className="form-label">
                            Fail Safe Timeout
                            <span className="text-muted small d-block">Timeout de segurança</span>
                        </label>
                        <input
                            type="number"
                            id="prebid[failSafeTimeout]"
                            name="prebid[failSafeTimeout]"
                            className="form-control"
                            onChange={handleForm.handleChange}
                            value={handleForm.values.prebid.failSafeTimeout}
                            placeholder="2000"
                            min="100"
                            max="10000"
                        />
                    </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group">
                        <label htmlFor="prebid[minFloor]" className="form-label">
                            Floor Mínimo
                            <span className="badge bg-primary ms-2">
                                {handleForm.values.adServerCurrency || 'USD'}
                            </span>
                            <span className="text-muted small d-block">
                                Valor mínimo para o preço do anúncio
                            </span>
                        </label>
                        <input
                            type="number"
                            step="0.01"
                            id="prebid[minFloor]"
                            name="prebid[minFloor]"
                            className="form-control"
                            onChange={handleForm.handleChange}
                            value={handleForm.values.prebid.minFloor}
                            placeholder="0.10"
                            min="0"
                        />
                    </div>
                    </div>
                </div>
            </div>

            <div className="settings-section">
                <h3 className="section-title" data-icon="💰">Price Granularity</h3>

                <div className="row g-3">
                    <div className="col-12">
                    <div className="form-group">
                    <label htmlFor="prebid[priceGranularity]" className="form-label">
                        Granularidade de Preços
                    </label>
                    <select
                        id="prebid[priceGranularity]"
                        name="prebid[priceGranularity]"
                        className="form-select"
                        onChange={handleForm.handleChange}
                        value={handleForm.values.prebid.priceGranularity}
                    >
                        <option value="low">📊 Low (0.50 increments)</option>
                        <option value="medium">📈 Medium (0.10 increments)</option>
                        <option value="high">📊 High (0.01 increments)</option>
                        <option value="auto">🤖 Auto</option>
                        <option value="dense">📋 Dense</option>
                        <option value="custom">⚙️ Custom</option>
                    </select>
                    </div>
                    </div>

                {handleForm.values.prebid.priceGranularity === 'custom' && (
                    <div className="col-12">
                    <div className="form-group">
                        <label htmlFor="prebid[priceGranularityCustom]" className="form-label">
                            Custom Price Granularity
                            <span className="text-muted small d-block">JSON com configuração customizada</span>
                        </label>
                        <textarea
                            id="prebid[priceGranularityCustom]"
                            name="prebid[priceGranularityCustom]"
                            className="form-control json-textarea"
                            rows={6}
                            onChange={handleForm.handleChange}
                            value={handleForm.values.prebid.priceGranularityCustom}
                            placeholder={`[
  { "precision": 2, "min": 0, "max": 5, "increment": 0.01 },
  { "precision": 2, "min": 5, "max": 10, "increment": 0.05 }
]`}
                        />
                    </div>
                    </div>
                )}
                </div>
            </div>
        </div>
    );
};

export default PrebidTab;